import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button, Box, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import backgroundImage from '../assets/img/background.jpg';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { FONT_FAMILY } from '../common/sharedFunctions';
import { colors as col } from "../components/Theme/WebTheme";

const Hero = (props) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const navigate = useNavigate();
  const role = props.role;
  const [loggedIn, setLoggedIn] = useState(false);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);

  useEffect(() => {
    if (auth.profile && auth.profile.uid) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [auth.profile]);

  const chips = [
    t('hero_chip_1', { defaultValue: 'Precio antes de confirmar' }),
    t('hero_chip_2', { defaultValue: 'Conductor verificado' }),
    t('hero_chip_3', { defaultValue: 'Seguimiento en tiempo real' }),
    t('hero_chip_4', { defaultValue: 'Disponible 24/7' }),
  ];

  const goPrimary = (e) => {
    e.preventDefault();
    if (loggedIn) {
      navigate(((role && role === 'driver') || (settings && settings.appCat === 'bidcab' && (role === 'admin' || role === 'fleetadmin'))) ? '/bookings' : '/addbookings');
    } else {
      navigate('/login');
    }
  };

  const goSecondary = (e) => {
    e.preventDefault();
    const el = document.getElementById('car-types');
    if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Box
      className={classes.heroBox}
      sx={{
        position: 'relative',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}
    >
      {/* Capa oscura para que el texto resalte sobre la imagen */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: isRTL === 'rtl'
            ? 'linear-gradient(270deg, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.6) 45%, rgba(0,0,0,0.15) 100%)'
            : 'linear-gradient(90deg, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.6) 45%, rgba(0,0,0,0.15) 100%)',
        }}
      />
      <Grid container spacing={6} className={classes.gridContainer} sx={{ position: 'relative', zIndex: 1 }}>
        <Grid item xs={12} md={8}>
          <Typography
            variant="h2"
            className={`${classes.titleMain} ai-gradient-text ai-rise`}
            sx={{ color: '#fff', fontFamily: FONT_FAMILY, fontWeight: 800, fontSize: { xs: 34, md: 56 }, lineHeight: 1.1 }}
          >
            {t('book_your_title')}
          </Typography>
          <Typography
            className={classes.subtitleMain}
            sx={{ color: '#eaeaea', fontFamily: FONT_FAMILY, fontSize: { xs: 16, md: 20 }, maxWidth: 620, opacity: 1, mt: 1.5 }}
          >
            {t('about_us_content2')}
          </Typography>

          <Stack direction="row" spacing={1.2} sx={{ flexWrap: 'wrap', gap: 1.2, mb: 3, mt: 1 }}>
            {chips.map((c, i) => (
              <Box
                key={i}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 0.6,
                  backgroundColor: 'rgba(255,255,255,0.12)',
                  border: '1px solid rgba(255,255,255,0.25)',
                  borderRadius: '999px', px: 1.5, py: 0.6,
                }}
              >
                <CheckCircleIcon sx={{ color: col.GREEN, fontSize: 18 }} />
                <Typography sx={{ color: '#fff', fontFamily: FONT_FAMILY, fontSize: 13 }}>{c}</Typography>
              </Box>
            ))}
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button
              variant="contained"
              onClick={goPrimary}
              sx={{
                backgroundColor: col.GREEN, color: '#fff', fontFamily: FONT_FAMILY,
                fontSize: 16, fontWeight: 700, px: 4, py: 1.3, borderRadius: '14px',
                textTransform: 'none', boxShadow: '0 8px 20px rgba(12,171,3,0.35)',
                '&:hover': { backgroundColor: '#0a9603' },
              }}
            >
              {role === 'driver' || (settings && settings.appCat === 'bidcab' && (role === 'admin' || role === 'fleetadmin')) ? t('info') : t('book_your_ride_menu')}
            </Button>
            <Button
              variant="outlined"
              onClick={goSecondary}
              sx={{
                color: '#fff', borderColor: 'rgba(255,255,255,0.6)', fontFamily: FONT_FAMILY,
                fontSize: 16, fontWeight: 600, px: 3.5, py: 1.3, borderRadius: '14px',
                textTransform: 'none',
                '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.08)' },
              }}
            >
              {t('hero_secondary_cta', { defaultValue: 'Ver tipos de grúa' })}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Hero;
